export default {
    leaveQuota: 'โควต้าการลา',
    fullTimeLeave: 'พนักงานประจำ',
    personalLeave: 'ลากิจ',
    sickLeave: 'ลาป่วย',
    annualResetDate: 'รีเซ็ทประจำปี',
    saveChanges: 'บันทึก',
    probation: 'พนักงานทดลองงาน',
    probationLeave: 'พนักงานทดลองงาน',
    congratulation: 'ยินดีด้วย',
    leaveQuotaIsUpdated: 'โควต้าการลาถูกอัปเดตแล้ว'
}
